import SamplesPage from '@/pages/Samples/SamplesPage';
import { useAppStore } from '@/stores/app';
import { SUPER_ADMIN_ROLE } from '@/types';
import { hasOrgRole } from '@helpers/roles';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/samples/')({
  beforeLoad: ({ context, location }) => {
    if (context.authentication.status === 'PENDING') return;

    const store = useAppStore.getState();
    const selectedOrganization = store.selectedOrganization || store.selectedOrgStub;

    if (context.authentication.status === 'UNAUTHENTICATED') {
      throw redirect({
        to: '/login',
      });
    }

    if (!selectedOrganization) {
      if (typeof window !== 'undefined') {
        sessionStorage.setItem('unauthorized_referrer', location.pathname);
      }
      throw redirect({ to: '/unauthorized' });
    }

    // Org-aware role check for SuperAdmin using helper
    if (context.authentication.status === 'AUTHENTICATED' && context.authentication.user && selectedOrganization?.id) {
      const orgId = selectedOrganization.id;
      const rolesRaw = context.authentication.user.assumed_roles;
      if (!hasOrgRole(rolesRaw, orgId, SUPER_ADMIN_ROLE)) {
        if (typeof window !== 'undefined') {
          sessionStorage.setItem('unauthorized_referrer', location.pathname);
        }
        throw redirect({ to: '/unauthorized' });
      }
    }
  },
  component: SamplesPage,
});
